import {HttpErrorResponse, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {catchError, Observable, retry, throwError, timer} from "rxjs";
import {nonBlank} from "../libs/utils/epic.utils";
import {inject, Injectable} from "@angular/core";
import {AuthService} from "../services/auth/auth.service";
import {UrlBuilder} from "./item/url.item";

export const errorInterceptor: HttpInterceptorFn = (request, next) => {

  const handler: ErrorHandler = inject(ErrorHandler);

  return next(request).pipe(
    // A 401 with the session cookie is retried once: right after login core may reject a token it has not introspected yet.
    retry({
      count: 1,
      delay: (error) => handler.isRetryable(error, request) ? timer(ErrorHandler.RETRY_DELAY_MS) : throwError(() => error)
    }),
    catchError((ex: HttpErrorResponse) => {
      if (ex.status === 0 && ex.url && ex.url.indexOf(UrlBuilder.getApiHostname()) > 0) {
        // TODO use ping
        // TODO handle error: Unable to Connect to the Server
      } else if (ex.error && ex.error.dataType && nonBlank(ex.error.dataType) && ex.error.dataType === 'ExceptionErrorDto') {
        // TODO handle acc error
      } else {
        handler.handleError(ex, request);
      }
      return new Observable<any>((obs) => {
        obs.error(ex);
        obs.complete();
      });
    }));
};

@Injectable({providedIn: 'root'})
export class ErrorHandler {

  public static readonly RETRY_DELAY_MS: number = 1000;

  private static readonly ERROR_PATH: string = '/v1/error/';

  private readonly auth: AuthService = inject(AuthService);

  public handleError(ex: HttpErrorResponse, request: HttpRequest<unknown>): void {
    // Telemetry must never log out: a 401 of the error report only means the session ended while reporting
    if (ex.status === 401 && this.auth.isAuthenticated() && !this.isErrorEndpoint(ex.url) && request.withCredentials) {
      this.auth.logOut();
    }
  }

  public isRetryable(error: unknown, request: HttpRequest<unknown>): boolean {
    return error instanceof HttpErrorResponse && error.status === 401 && !this.isErrorEndpoint(error.url) && request.withCredentials;
  }

  private isErrorEndpoint(url: string | null): boolean {
    return nonBlank(url) && url!.includes(ErrorHandler.ERROR_PATH);
  }
}
